import { Component } from '@angular/core';

@Component({
  selector: 'flxion-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  constructor() { }

}
